import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "invite-list"
};
const _hoisted_2 = {
  class: "pagination"
};
import nodata from "@/assets/img/no-data.png";
import { onMounted, ref } from "vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat } from "@/utils/libs";
import Clipboard from "clipboard";
export default {
  __name: 'InviteList',
  setup(__props) {
    const items = ref([]);
    const total = ref(0);
    const page = ref(1);
    const pageSize = ref(10);
    const loading = ref(true);
    onMounted(() => {
      fetchData();
      const clipboard = new Clipboard(".copy-order-no");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });

    // 获取数据
    const fetchData = () => {
      httpGet("/invite/list", {
        page: page.value,
        page_size: pageSize.value
      }).then(res => {
        if (res.data) {
          items.value = res.data.items;
          total.value = res.data.total;
          page.value = res.data.page;
          pageSize.value = res.data.page_size;
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [items.value.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "username",
            label: "用户"
          }), _createVNode(_component_el_table_column, {
            prop: "invite_code",
            label: "邀请码"
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "邀请奖励"
          }), _createVNode(_component_el_table_column, {
            label: "注册时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无数据"
      }, null, 8, ["image"])), _createElementVNode("div", _hoisted_2, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "total,prev, pager, next",
        "hide-on-single-page": true,
        "current-page": page.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        style: {
          "--el-pagination-button-bg-color": "rgba(86, 86, 95, 0.2)"
        },
        onCurrentChange: _cache[2] || (_cache[2] = $event => fetchData()),
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])), [[_directive_loading, loading.value]]);
    };
  }
};